import { HttpClientModule } from '@angular/common/http'
import '@angular/common/locales/global/pl'
import { Injector, LOCALE_ID, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap'
import { provideEnvironmentNgxMask } from 'ngx-mask'
import 'src/app/shared/utils/string-util'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CoreModule } from './core/core.module'
import { AppLanguageService } from './core/services/app-language.service'
import { CustomNgbDatepickerI18n } from './core/services/ngb-datepicker-i18n.service'
import { ErrorMessageComponent } from './shared/components/error-message/error-message.component'

const getLocaleId = (inject: Injector): string => {
    const languageService: AppLanguageService = inject.get(AppLanguageService)
    return languageService.getAppLanguage()
}

@NgModule({
    declarations: [AppComponent, ErrorMessageComponent],
    imports: [BrowserModule, HttpClientModule, CoreModule, AppRoutingModule],
    providers: [
        { provide: LOCALE_ID, useFactory: getLocaleId, deps: [Injector] },
        { provide: NgbDatepickerI18n, useClass: CustomNgbDatepickerI18n },
        provideEnvironmentNgxMask({ decimalMarker: ',' })
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
